<div class="flex items-center gap-4 bg-white border border-light focus-within:border-primary_text p-3 pl-4 rounded-md">
  <i
    class="pi text-xl h-7 aspect-square text-center"
    [ngClass]="documentIcon"></i>
  <div class="flex flex-col flex-1 gap-1 overflow-hidden">
    <span class="font-bold overflow-hidden text-nowrap text-ellipsis">{{ document && document.name }}</span>
    <span class="text-xs text-medium_light"
      >{{
        document &&
          (document.isCustomCategory
            ? document.category
            : (getGenericCategoryTranslationUri(document.category) | translate))
      }}
      | {{ document && document.uploadDate | date: "dd.MM.yyyy" }}</span
    >
  </div>
  <p-menu
    #optionMenu
    [model]="menuItems"
    [popup]="true">
    <ng-template
      pTemplate="item"
      let-item>
      <a
        pRipple
        class="flex p-menuitem-link gap-4">
        <span [class]="item.icon"></span>
        <span>{{ item.label }}</span>
      </a>
    </ng-template>
  </p-menu>
  <button
    [title]="'storedDocuments.documentActionsButtonTitle' | translate"
    (click)="optionMenu.toggle($event)"
    class="p-2">
    <i class="pi pi-ellipsis-v text-xl"></i>
  </button>
</div>
